import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import CookieConsent from "./components/feature/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-bg text-text-body">
          <Navbar />
          <div className="flex-1">
            <AppRoutes />
          </div>
          <Footer />
          <CookieConsent />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;